module.exports = __webpack_public_path__ + "untitled-serif-700.2d880753008bb8c1f50826f2792111c6.woff2";